import { Controller } from 'stimulus';

// A form field set with the house toggle (.ui-seg, dark slate when on;
// docs/UI_STYLE_GUIDE.md) in place of radio buttons: the pressed button's
// data-value goes into the hidden input that posts. First on Edit Task's
// Include in Reports (jobs/tasks/_form_slim).
export default class extends Controller {
  static targets = ['input']

  pick(event) {
    const button = event.currentTarget;
    this.inputTarget.value = button.dataset.value;
    this.element.querySelectorAll('button[data-value]').forEach((b) => {
      b.classList.toggle('is-on', b === button);
      b.setAttribute('aria-pressed', String(b === button));
    });
  }
}
